
export class patronage {

  public accountID: number;
  public totalValue?: number;
  public perc?: number;
  public shares?: number;
  public balance?: number;
  public profit?: number;
  public dividend?: number;
  public payment?: number;
  public credit?: number;
  public dateLoaded?: number;
  public batchID?: number;
  public stockValue?: number;
  public taxWithholding?: number;
  public withdrawl?: number;
  public endingRetention?: number;
  public endingBalance?: number;
  constructor(o?: any) {
    Object.assign(this, o);
  }
}


